import React from 'react';
import styled from 'styled-components';

const WrapperStyled = styled.div`
  min-height: 20px;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
  h1 {
    font-size: 45px;
  }
  p {
    font-size: 22px;
  }
`;

export default function Wrapper({ children }) {
  return <WrapperStyled>{children}</WrapperStyled>;
}
